import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {Fournisseur} from '../../models/fournisseur';

@Injectable({
  providedIn: 'root'
})
export class FournisseurEventService {

    private fournisseurArchiveEvent = new Subject<{ fournisseur: Fournisseur, is_archive: boolean }>();
    private fournisseurSubject = new BehaviorSubject<Fournisseur | null>(null);

    emitFournisseurArchiveEvent(fournisseur: Fournisseur, is_archive: boolean) {
        this.fournisseurArchiveEvent.next({ fournisseur, is_archive });
    }

    onFournisseurArchiveEvent() {
        return this.fournisseurArchiveEvent.asObservable();
    }

    updateFournisseur(fournisseur: Fournisseur | null): void {
        this.fournisseurSubject.next(fournisseur);
    }

    getFournisseur(): Observable<Fournisseur | null> {
        return this.fournisseurSubject.asObservable();
    }
}
